module.exports = __webpack_public_path__ + "static/ApercuMonoProMedium-17125ea91bfd4beeb4ec21502b86a4c5.ttf";